mutation StartGiveaway($giveawayId: ID!) {
  giveaway: StreamToolsStartGiveaway(giveawayId: $giveawayId) {
    giveawayId
    status
    entrantCount
    hasDraw
    startedAt
    closedAt
    publishedAt
    version
    winners {
      login
      displayName
      rank
      kind
    }
  }
}
